import { useEffect, useState } from "react";
import { sitePolicy } from "../asiosConfig";
import { toast } from "react-toastify";

export const useSitePolicy = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const response = await sitePolicy();
        if (response.status === 200 || response.status === 201) {
          setData(response.data.data);
        } else {
          toast.error("Failed to fetch policy data");
        }
      } catch (error) {
        toast.error("Failed to fetch policy data");
      } finally {
        setLoading(false);
      }
    };

    fetchPolicy();
  }, []);

  return { data, loading };
};
